<template>
  <div class="Page">
    <!--Banner-->
    <section class="">
        <div class="banner">
            <h1 class="PageTitle" style="">Promotions</h1>
        </div>
        <div class="orangeStripe"></div>
    </section>
    
    <!--Promos dynamiques (affichées selon les dates)-->
    <section class="bgPromo">

      <v-row v-for="promo in promosActives" :key="promo.id">
        <v-col cols="12" class="d-flex align-center justify-center">
          <img class="promoImg" :src="promo.image" :alt="promo.alt" />
        </v-col>
        <v-col v-if="promo.infoMessage" cols="12" class="d-flex align-center justify-center">
          <p class="promoInfoMessage" v-html="promo.infoMessage"></p>
        </v-col>
        <v-col cols="12" class="d-flex align-center justify-center">
          <a v-if="promo.phone" style="margin: 50px 0px;" class="priBtn" :href="'tel:' + promo.phone">{{ promo.phoneLabel || 'Appelez-nous' }}</a>
          <a v-else style="margin: 50px 0px;" class="priBtn" :href="promo.pdf" download>Télécharger la promotion</a>
        </v-col>
      </v-row>
      
      <div class="orangeStripe"></div>
    </section>

    <section>
      <v-row no-gutters>
        <v-col class="heightNewsletter" style="">
          <div class="newsletterOverlay" style=""></div>
          <img src="../../public/ressources/images/career/job/applyImg.jpg" style="height: 100%; width: 100%; object-fit: cover; object-position: center;" title="Promotion pièce réseau dynamique" alt="image d'un téléphone pour montrer une photo pour des promotions et logo de réseau dynamique" />
        </v-col>
        <v-col class="d-flex align-center justify-center bgPromoNewsletter" >
          <v-row class="paNewsletter">
            <v-row> <v-col><h2>ABONNEZ-VOUS !</h2></v-col> </v-row>
            <v-row> <v-col><p>Vous aimeriez recevoir des rabais exclusifs chaque semaine. Il suffit de vous inscrire à notre infolettre pour recevoir en premier nos promotions. Profitez-en dès maintenant ! </p></v-col> </v-row>
            <v-row><v-col><a href="https://app.cyberimpact.com/clients/47814/subscribe-forms/4703B382-EB45-468E-A900-F7EA2052DCD9" target="_blank"><button class="priBtn" style="padding: 0px 60px;">S'inscrire</button></a></v-col></v-row>
          </v-row>
        </v-col>
      </v-row>
    </section>
  </div>
</template>
<style scoped>
    .PageTitle { position: absolute; top: 40%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    .banner { position: relative; height: 500px; background-image: url('../../public/ressources/images/promotions/headerPromo.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .bgPromo { height: 100%; background-image: url('../../public/ressources/images/promotions/bgPromo.jpg'); background-position: bottom center; background-repeat: no-repeat; background-size: cover;  }
    .paPromo { padding: 150px 5%; }
    .textPromo { text-align: center; font-family: TxtOffBDI; font-size: 24px; color: white; text-transform: uppercase; }
    .subtextPromo { text-align: center; padding: 10px 0px; font-family: TxtOffBDI; font-size: 18px; color: white; text-transform: uppercase; }
    /*#region compagny*/
      .heightNewsletter { position: relative; max-height: 550px; min-width: 350px; }
      .newsletterOverlay { position: absolute; height: 100%; width: 100%; background-color: rgba(000,000,000, 0.5); }   
      .bgPromoNewsletter { background-color: black; color: white; min-width: 350px; }
      .bgPromoNewsletter h2 { font-family: TxtOffBDI; font-size: 36px; }
      .bgPromoNewsletter p { font-family: TxtOffRe; font-size: 27px; padding: 25px 0px; }
      .paNewsletter { padding: 0px 15%; }
    /*#endregion */
    /*#region slider*/
      .Container {padding: 0px 50px; line-height: normal; height: 100%;}
      .imgPromoContainer { height: 400px; max-width: 50%; min-width: 350px; position: relative;}
      .widthPrice { max-width: 80px; }
      .price { font-size: 113px !important; }
      .widthSold { max-width: 300px; }
      .sold { font-size: 46px !important; line-height: 1em; text-transform: uppercase; }
      .promoImg { padding: 50px 0px; max-height:700px; }
    .promoInfoMessage { font-family: TxtOffBDI; font-size: 22px; color: white; text-align: center; padding: 30px 20px 0px 20px; text-transform: uppercase; }
      .sliderHeight {height: fit-content !important;}
      .paSlider { padding-bottom: 100px; }
      .itemText h2 { font-family: TxtOffBDI; font-size: 36px; color: white;}
      .itemText p { font-family: TxtOffRe; font-size: 18px; padding: 25px 0px; color: white; text-align: center; }
      .storyArrow { display: block; }
      .arrowPaging { position: absolute; font-size: 76px; cursor: pointer; color: rgb(var(--primary)); z-index: 1000;}
      .arrowPaging:hover { color: white; text-shadow: 0px 0px 8px rgb(var(--primary)); }
      .arrowNext { padding-left: 40px; top:40%; right: 1%; }
      .arrowPrev { padding-right: 20px; top:40%; left: 1%; }
    /*#endregion */
      
    
    @media handheld, only screen and (max-width: 600px) {
      .sliderHeight {height: fit-content !important;}
      .arrowNext { top:50%; }
      .arrowPrev { top:50%; }
      .paPromo { padding: 50px 10px; }
      .textPromo { font-size: 18px; }
      .subtextPromo { font-size: 14px; }
      
    }
    @media handheld, only screen and (max-width: 960px) {
      .Container { padding: 0px 10px; height: unset; }
      .bgPromoNewsletter { padding: 10px !important;}
      .imgPromoContainer { max-width: unset; max-height: unset; }
      .promoImg { padding: 0px; max-height:auto; max-width:95%; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'Promo',
  data:()=>({
    now: new Date(),
    /**
     * Liste des promotions temporaires.
     * Pour ajouter une nouvelle promo : copier un objet, modifier les dates et fichiers.
     * dateDebut : premier jour d'affichage (inclus) — format 'AAAA-MM-JJ'
     * dateFin   : dernier jour d'affichage (inclus, jusqu'à 23:59:59)
     */
    promotions: [
      {
        id: 'lancementFleetriteOctobre2026',
        dateDebut: '2026-10-01',
        dateFin: '2026-10-16',
        image: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Lancement_Fleetrite_1_au_16_Oct_2026_v2.jpg',
        pdf: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Lancement_Fleetrite_1_au_16_Oct_2026_v2.pdf',
        alt: 'Promotion de lancement Fleetrite — du 1er au 16 octobre 2026 — Réseau Dynamique'
      },
      {
        id: 'ancraCargoOctobre2026',
        dateDebut: '2026-10-06',
        dateFin: '2026-10-31',
        image: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Ancra_Cargo_6_au_31_Oct_2026.jpg',
        pdf: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Ancra_Cargo_6_au_31_Oct_2026.pdf',
        alt: 'Promotion Ancra Cargo — essentiels d\'arrimage — du 6 au 31 octobre 2026 — Réseau Dynamique'
      },
      {
        id: 'piecesRouesOctobre2026',
        dateDebut: '2026-10-06',
        dateFin: '2026-10-31',
        image: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Pieces_Roues_6_au_31_Oct_2026.jpg',
        pdf: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Pieces_Roues_6_au_31_Oct_2026.pdf',
        alt: 'Promotion pièces pour roues — protégez vos roues, équipez votre camion — du 6 au 31 octobre 2026 — Réseau Dynamique'
      },
      {
        id: 'speciauxAutomnauxFleetrite2026',
        dateDebut: '2026-10-16',
        dateFin: '2026-12-31',
        image: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Speciaux_Automnaux_Fleetrite_16_Oct_au_31_Dec_2026.jpg',
        pdf: '/ressources/images/promotions/octobre/Reseau_Dynamique_Promo_Speciaux_Automnaux_Fleetrite_16_Oct_au_31_Dec_2026.pdf',
        alt: 'Spéciaux automnaux Fleetrite — assécheurs d\'air, cartouches et valves de purge — jusqu\'au 31 décembre 2026 — Réseau Dynamique'
      }
    ]
  }),
  computed: {
    /** Retourne uniquement les promos dont la date actuelle est dans l'intervalle [dateDebut, dateFin] */
    promosActives() {
      const aujourd_hui = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
      return this.promotions.filter(promo => {
        const debut = this.parseDate(promo.dateDebut);
        const fin = this.parseDate(promo.dateFin);
        return aujourd_hui >= debut && aujourd_hui <= fin;
      });
    }
  },
  mounted() {
    // Meta tags SEO
    document.title = 'Promotions pièces camions | Rabais Fleetrite, Shell Rotella — Réseau Dynamique';
    this.setMeta('description', 'Profitez des promotions en cours sur les pièces de camions chez Réseau Dynamique. Rabais sur pièces Fleetrite, Shell Rotella, amortisseurs, filtres et plus. Offres valides dans nos 22 succursales au Québec.');
    this.setMeta('og:title', 'Promotions pièces camions — Réseau Dynamique');
    this.setMeta('og:description', 'Rabais exclusifs sur les pièces de camions International. Fleetrite, Shell Rotella, amortisseurs et plus. 22 concessionnaires au Québec.');
    this.setMeta('og:type', 'website');
    this.setMeta('og:url', 'https://reseaudynamique.com/promotion');
    this.setMeta('og:image', 'https://reseaudynamique.com/ressources/images/promotions/headerPromo.jpg');

    // Rafraîchir la date à chaque minute (au cas où la page reste ouverte à minuit)
    this.timerDate = setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeDestroy() {
    if (this.timerDate) clearInterval(this.timerDate);
  },
  methods: {
    /** Helper pour ajouter/mettre à jour les balises meta */
    setMeta(name, content) {
      const isOg = name.startsWith('og:');
      const attr = isOg ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    },
    /** Convertit une chaîne 'AAAA-MM-JJ' en objet Date (minuit, heure locale) */
    parseDate(dateStr) {
      const [annee, mois, jour] = dateStr.split('-').map(Number);
      return new Date(annee, mois - 1, jour);
    }
  },
  components: { }
}
</script>